import {NgModule} from '@angular/core';
import {TopManagementComponent} from './top-management.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TopManagementRoutingModule} from './top-management-routing.module';
import {CreateTmComponent} from './create-tm/create-tm.component';
import {NgSelect2Module} from 'ng-select2';
import {ListStrategyActionsComponent} from './list-strategy-actions/list-strategy-actions.component';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ViewTmPostComponent} from './view-tm-post/view-tm-post.component';
import {EditTmComponent} from './edit-tm/edit-tm.component';
import {SharedModuleModule} from '../../../shared-module/shared-module.module';
import {ListProfitabilityComponent} from './list-profitability/list-profitability.component';
import {ListCompetitionComponent} from './list-competition/list-competition.component';
import {ListDevelopmentOpportunitiesComponent} from './list-development-opportunities/list-development-opportunities.component';
import {ListOthersComponent} from './list-others/list-others.component';


@NgModule({
    declarations: [TopManagementComponent, CreateTmComponent, ListStrategyActionsComponent,
        ViewTmPostComponent, EditTmComponent, ListProfitabilityComponent, ListCompetitionComponent,
        ListDevelopmentOpportunitiesComponent, ListOthersComponent],
    imports: [
        CommonModule,
        FormsModule,
        TopManagementRoutingModule,
        NgSelect2Module,
        NgbPaginationModule,
        SharedModuleModule
    ]
})

export class TopManagementModule {
}
